import React, { useState, useEffect, useMemo } from 'react';
import { FlatList, ScrollView, SectionList, TouchableOpacity, View } from 'react-native'

import api from "@/utils/api"
import tw from '@/styles/tailwind';
import Text from '@/components/Text';
import Icon from '@/components/IcomoonIcon';
import { Image } from 'expo-image';
import { useQuery } from '@tanstack/react-query';

import IconButton from '@/components/IconButton';
import { useNavigation } from '@react-navigation/native';
import Modal from '@/components/Modal';
import Select from '@/components/Forms/Select';
import { useForm } from 'react-hook-form';
import Input from '@/components/Forms/Input';
import useFormSubmit from '@/hooks/useFormSubmit';



export default function NewProviderModal({ communityId, onRequestClose, onProviderCreated }) {
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const { control, handleSubmit, formState, formState: { errors }, setError, setValue, watch } = useForm();


  const { isInitialLoading, error, data: providers, refetch } = useQuery({
    queryKey: ['vinte.providers', communityId],
    queryFn: () => api.get(`/vinte/providers?community_id=${communityId}`).then(response => response.data),
  })


  const { submitForm: submit, isSubmitting } = useFormSubmit({
    onSuccess: onProviderCreated,
    onError: (error) => { },
    successToastMessage: "Proveedor registrado correctamente",
    method: "post",
    endpoint: `/vinte/communities/${communityId}/providers`,
  })

  const navigation = useNavigation()

  
  const submitForm = data => {
    console.log(data)
    submit(data)
  }

  return (
    <Modal 
      onRequestClose={onRequestClose}
      title='Nuevo proveedor'
      style={{ content: `px-5`}}
    >

      <View style={tw``}>
        <Text style={tw`text-gray-700 font-500`}>Nombre</Text>

        <Input
          control={control}
          name='name'
          placeholder=''
          rules={{ required: true }}
          style={{ container: `mb-4` }}
        />
      </View>

      <View style={tw``}>
        <Text style={tw`text-gray-700 font-500`}>RFC</Text>

        <Input
          control={control}
          name='rfc'
          placeholder=''
          rules={{ required: true }}
          style={{ container: `mb-4` }}
        />
      </View>


      <View style={tw`row justify-between mb-3`}>
        <Text style={tw`text-gray-700 font-500`}>Tipo</Text>

        <Select
          control={control}
          name={"entity_type"}
          placeholder={{ value: "", label: "Elegir" }}
          items={[
            { value: "fisica", label: "Física" },
            { value: "moral", label: "Moral" },
          ]}
          rules={{ required: true }}
          style={{ input: tw`bg-gray-100`, wrapper: `mb-0` }}
        />
      </View>

      <View style={tw`row justify-between`}>
        <Text style={tw`text-gray-700 font-500`}>Categoría</Text>

        <Select
          control={control}
          name={"type"}
          placeholder={{ value: "", label: "Elegir" }}
          items={[
            { value: "fisica", label: "Servicios" },
            { value: "moral", label: "Construcción" },
          ]}
          rules={{ required: true }}
          style={{ input: tw`bg-gray-100`, wrapper: `mb-0` }}
        />
      </View>



      <View style={tw`border-t border-gray-200 mt-4 mb-4 h-1`}></View>

      <Text style={tw`text-secondary text-base font-500 text-center`}>Datos bancarios</Text>

      {/* Banco */}
      <View style={tw`row mb-3`}>
        <Text style={tw`text-gray-700 font-500`}>Banco</Text>

        <Input
          control={control}
          name='bank.bank'
          placeholder='ej: BBVA'
          rules={{ required: false }}
          style={{ container: `mb-0 ml-6` }}
        />
      </View>


      {/*  */}
      <View style={tw``}>
        <Text style={tw`text-gray-700 font-500`}>No. de Cuenta</Text>

        <Input
          control={control}
          name='bank.account_number'
          placeholder=''
          rules={{ required: false, minLength: 6 }}
        />
      </View>

      {/*  */}
      <View style={tw``}>
        <Text style={tw`text-gray-700 font-500`}>CLABE</Text>

        <Input
          control={control}
          name='bank.clabe'
          placeholder=''
          rules={{ required: false, minLength: 18 }}
          maxLength={18}
        />
      </View>

      <IconButton
        title={"Dar de alta proveedor"}
        color='secondary'
        textColor='white'
        style={tw`rounded-2xl py-3`}
        onPress={handleSubmit(submitForm)}
        disabled={isSubmitting}
      />

    </Modal>
  )
}